import { Phone, MapPin, Clock, User } from "lucide-react";

const LOCATIONS = [
  {
    city: "Fetești",
    person: "Alina Gheorghe",
    phone: "0766 693 105",
    phoneRaw: "0766693105",
    address: "Zona Industrială 804",
  },
  {
    city: "Slobozia",
    person: "Smău Vasile",
    phone: "0722 569 492",
    phoneRaw: "0722569492",
    address: "Șos. Brăilei nr. 25E, Zona Industrială Nord-Est",
  },
];

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-[#0A0A0A] text-white pt-20 pb-10 relative overflow-hidden">
      <div aria-hidden className="absolute inset-0 grain opacity-40" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="grid grid-cols-12 gap-10 pb-16 border-b border-white/10">
          <div className="col-span-12 lg:col-span-5">
            <h3 className="font-display text-5xl sm:text-6xl lg:text-7xl uppercase leading-[0.85] tracking-tight">
              Apolodor<br />
              <span className="text-[#F59E0B]">Com SRL</span>
            </h3>
            <p className="mt-6 text-sm text-neutral-400 max-w-md leading-relaxed">
              Stație de betoane · Peste 30 de ani experiență în construcții rezidențiale și nerezidențiale.
              Două puncte de lucru: Fetești și Slobozia.
            </p>
            <div className="mt-6 font-mono-tech text-[11px] tracking-[0.2em] uppercase text-neutral-500 flex items-center gap-2">
              <Clock className="w-3.5 h-3.5 text-[#F59E0B]" />
              Luni — Vineri · 08:00 — 17:00
            </div>
          </div>

          <div className="col-span-12 lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-px bg-white/10 border border-white/10">
            {LOCATIONS.map((l) => (
              <div key={l.city} data-testid={`footer-loc-${l.city.toLowerCase()}`} className="bg-[#0A0A0A] p-6 flex flex-col gap-4">
                <div className="font-mono-tech text-[10px] tracking-[0.25em] uppercase text-[#F59E0B]">
                  {l.city}
                </div>
                <div>
                  <div className="flex items-center gap-2 text-neutral-400">
                    <User className="w-3.5 h-3.5" />
                    <span className="font-mono-tech text-[10px] tracking-[0.2em] uppercase">Contact</span>
                  </div>
                  <div className="font-display text-xl uppercase tracking-tight mt-1">{l.person}</div>
                </div>
                <a href={`tel:${l.phoneRaw}`} className="hover:opacity-80 transition-opacity">
                  <div className="flex items-center gap-2 text-neutral-400">
                    <Phone className="w-3.5 h-3.5 text-[#F59E0B]" />
                    <span className="font-mono-tech text-[10px] tracking-[0.2em] uppercase">Telefon</span>
                  </div>
                  <div className="font-display text-2xl uppercase tracking-tight mt-1">{l.phone}</div>
                </a>
                <div>
                  <div className="flex items-center gap-2 text-neutral-400">
                    <MapPin className="w-3.5 h-3.5" />
                    <span className="font-mono-tech text-[10px] tracking-[0.2em] uppercase">Adresă</span>
                  </div>
                  <div className="text-sm text-neutral-300 mt-1 leading-relaxed">{l.address}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="pt-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="font-mono-tech text-[11px] tracking-[0.2em] uppercase text-neutral-500">
            © {new Date().getFullYear()} Apolodor Com SRL · Toate drepturile rezervate
          </div>
          <div className="font-mono-tech text-[11px] tracking-[0.2em] uppercase text-neutral-500">
            CAEN 4120 · Construcții rezidențiale & nerezidențiale
          </div>
        </div>
      </div>
    </footer>
  );
}
